import { atsApiQuery } from '..';
import { getEmailFormData } from '../ats-applications/utils';

export const atsContactApi = atsApiQuery.injectEndpoints({
  endpoints: (builder) => {
    return {
      addExperience: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ payload, contactId }) => {
          return {
            url: `/contacts/${contactId}/ats_experiences`,
            method: 'post',
            data: payload,
          };
        },
      }),
      updateExperience: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ payload, contactId, experienceId }) => {
          return {
            url: `/contacts/${contactId}/ats_experiences/${experienceId}`,
            method: 'patch',
            data: payload,
          };
        },
      }),
      deleteExperience: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ contactId, experienceId }) => {
          return {
            url: `/contacts/${contactId}/ats_experiences/${experienceId}`,
            method: 'delete',
          };
        },
      }),
      bulkAddExperience: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ contactId, payload }) => {
          return {
            url: `/contacts/${contactId}/ats_experiences/bulk_create`,
            method: 'post',
            data: payload,
          };
        },
      }),
      addEducation: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ payload, contactId }) => {
          return {
            url: `/contacts/${contactId}/ats_educations`,
            method: 'post',
            data: payload,
          };
        },
      }),
      updateEducation: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ payload, contactId, educationId }) => {
          return {
            url: `/contacts/${contactId}/ats_educations/${educationId}`,
            method: 'patch',
            data: payload,
          };
        },
      }),
      deleteEducation: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ contactId, educationId }) => {
          return {
            url: `/contacts/${contactId}/ats_educations/${educationId}`,
            method: 'delete',
          };
        },
      }),
      getResumes: builder.query({
        providesTags: ['GetAtsContactsResume'],
        transformResponse: (response) => response?.data,
        query: ({ contactId }) => {
          return {
            url: `/contacts/${contactId}/resumes`,
            method: 'get',
          };
        },
      }),
      uploadResume: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ contactId, resume, is_primary }) => {
          var formdata = new FormData();
          formdata.append('resume', resume);
          if (contactId) {
            formdata.append('contact_id', contactId);
          }
          if (is_primary) {
            formdata.append('is_primary', 'true');
          }
          return {
            url: `/resume_parser/generate`,
            method: 'post',
            data: formdata,
          };
        },
        invalidatesTags: () => [{ type: 'GetAtsContactsResume' }],
      }),
      resumeParser: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ key }) => {
          return {
            url: `/resume_parser/generation_status?key=${key}`,
            method: 'get',
          };
        },
        invalidatesTags: () => [{ type: 'GetAtsContactsResume' }],
      }),
      createContactNote: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ contactId, payload }) => {
          return {
            url: `contacts/${contactId}/notes`,
            method: 'post',
            data: payload,
          };
        },
      }),

      updateContactNote: builder?.mutation({
        transformResponse: (response) => response?.data,
        query: ({ contactId, payload, noteId }) => {
          return {
            url: `contacts/${contactId}/notes/${noteId}`,
            method: 'patch',
            data: payload,
          };
        },
      }),
      getSimilarContacts: builder.query({
        transformResponse: (response) => response?.data,
        query: ({ contactId }) => {
          return {
            method: 'get',
            url: `/contacts/${contactId}/similar_contacts`,
          };
        },
      }),
      mergeContact: builder?.mutation({
        transformResponse: (response) => response?.data,
        query: ({ contactId, payload }) => {
          return {
            url: `contacts/${contactId}/merge`,
            method: 'post',
            data: payload,
          };
        },
      }),
      sendEmailForCandidate: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ contactId, params }) => {
          const fd = new FormData();
          const formData = getEmailFormData(fd, params);
          return {
            url: `contacts/${contactId}/email`,
            method: 'post',
            data: formData,
          };
        },
      }),
      getContactNotes: builder.mutation({
        transformResponse: (response) => response,
        query: ({ contactId, params }) => {
          return {
            url: `/contacts/${contactId}/notes`,
            method: 'get',
            params,
          };
        },
      }),
    };
  },
  overrideExisting: true,
});

export const {
  useAddExperienceMutation,
  useUpdateExperienceMutation,
  useDeleteExperienceMutation,
  useAddEducationMutation,
  useUpdateEducationMutation,
  useDeleteEducationMutation,
  useBulkAddExperienceMutation,
  useGetResumesQuery,
  useResumeParserMutation,
  useUploadResumeMutation,
  useCreateContactNoteMutation,
  useUpdateContactNoteMutation,
  useGetSimilarContactsQuery,
  useMergeContactMutation,
  useSendEmailForCandidateMutation,
  useGetContactNotesMutation,
} = atsContactApi;
